export const formatNumber = (num: number | string) => {
  const parts = num.toString().split(".");
  const integerPart = parts[0];
  const decimalPart = parts.length > 1 ? parts[1] : "";

  let formattedDecimalPart = decimalPart.padEnd(integerPart.length, "0");
  if (formattedDecimalPart.length > 0) {
    formattedDecimalPart = "." + formattedDecimalPart;
  }

  return (
    "$" +
    integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
    formattedDecimalPart
  );
};

export const formatCurrency = (num: number | string) => {
  const number = +num;
  return "$" + number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const isValidNumber = (value: any): value is number => {
  // First, check if the value is a string and is empty or only whitespace.
  if (typeof value === "string" && value.trim().length === 0) {
    return false;
  }

  // Then, use standard JavaScript number validation.
  // Number.isFinite() is a robust way to check for a valid, finite number
  // and it correctly handles string inputs that can be parsed as numbers.
  const num = Number(value);
  return Number.isFinite(num);
};
